import {
  FormGroup,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  Typography,
  Box,
} from "@mui/material";

const Checkbox = ({
  label,
  name,
  options,
  selectedOptions,
  onChange,
  disabledOptions = [],
  alwaysCheckedOptions = [],
  ...props
}) => {
  return (
    <Box sx={{ width: "100%", mb: 2.5 }}>
      <Typography
        component="label"
        sx={{
          display: "block",
          mb: 1,
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {label}
      </Typography>
      <FormGroup
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
        {...props}
      >
        {options.map((option) => {
          const isDisabled = disabledOptions.includes(option);
          const isAlwaysChecked = alwaysCheckedOptions.includes(option);
          const isChecked = isAlwaysChecked || selectedOptions.includes(option);

          return (
            <FormControlLabel
              key={option}
              control={
                <MuiCheckbox
                  checked={isChecked}
                  onChange={isDisabled ? undefined : onChange}
                  name={name}
                  value={option}
                  disabled={isDisabled}
                />
              }
              label={option.charAt(0).toUpperCase() + option.slice(1)}
              sx={{ mr: 1.875 }}
            />
          );
        })}
      </FormGroup>
    </Box>
  );
};

export default Checkbox;
